import config from '@/config'
const { storagePrefix } = config

export function getItem(key){
	let data = localStorage.getItem(storagePrefix + key)
	try{
		data = JSON.parse(data)
	}catch (e){}
	return data
}

export function setItem(key,value){
	value = JSON.stringify(value)
	return localStorage.setItem(storagePrefix + key, value)
}

export function removeItem(key){
	return localStorage.removeItem(storagePrefix + key)
}
